import LockIcon from './ic__outline_lock.svg';

export { LockIcon };
